import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

type MobilePasswordFieldProps = {
    value: string;
    placeholder: string;
    onChange: (value: string) => void;
    autoComplete: string;
    /** Omit to let the field manage its own show/hide state. */
    visible?: boolean;
    onToggle?: () => void;
};

const MobilePasswordField = ({ value, placeholder, visible, onChange, onToggle, autoComplete }: MobilePasswordFieldProps) => {
    const [internalVisible, setInternalVisible] = useState(false);

    const isControlled = visible !== undefined && onToggle !== undefined;
    const isVisible = isControlled ? visible : internalVisible;
    const toggle = isControlled ? onToggle : () => setInternalVisible((shown) => !shown);

    return (
        <label className="mobile-auth-field mobile-auth-password-field">
            <span className="sr-only">{placeholder}</span>
            <input
                type={isVisible ? "text" : "password"}
                placeholder={placeholder}
                autoComplete={autoComplete}
                value={value}
                onChange={(event) => onChange(event.target.value)}
            />
            {value.length > 0 && (
                <button
                    type="button"
                    className="mobile-auth-visibility-toggle"
                    onClick={toggle}
                    aria-label={`${isVisible ? "Hide" : "Show"} ${placeholder.toLowerCase()}`}
                    aria-pressed={isVisible}
                >
                    {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </button>
            )}
        </label>
    );
};

export default MobilePasswordField;
